import type { GetContractProductsOverviewsResponse } from '@vy/api-definition';
import { GetContractProductsOverviewsResponseSchema } from '@vy/api-definition';
import type { QueryClient } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useContractProductsOverviews(
  contractId: string,
  options?: CustomUseQueryOptions<GetContractProductsOverviewsResponse>,
) {
  return useQuery(
    queryKeys.contractProductsOverviews(contractId),
    async () => {
      return getContractProductsOverviews(contractId);
    },
    { suspense: true, ...options },
  );
}

export async function prefetchContractProductsOverviews(contractId: string, queryClient: QueryClient) {
  await queryClient.prefetchQuery(queryKeys.contractProductsOverviews(contractId), () =>
    getContractProductsOverviews(contractId),
  );
}

export async function getContractProductsOverviews(contractId: string) {
  const privateApi = getPrivateApi();
  const getContractProductsOverviewsResponse = await privateApi.getContractProductsOverviews({ contractId });

  return GetContractProductsOverviewsResponseSchema.parse(getContractProductsOverviewsResponse);
}
